import {unexpectedCase} from 'nutshell-core/reducer-utils';

import {ActionTypes} from './tasks-actions';
import type {CreatorTasksAction} from './tasks-actions';

export type CreatorTasksState = {
    isReadOnly: boolean;
};

const defaultCreatorTasksState = {
    isReadOnly: true,
} as const;

export const reducer = (
    state: CreatorTasksState | null | undefined = defaultCreatorTasksState,
    action: CreatorTasksAction
): CreatorTasksState => {
    switch (action.type) {
        case ActionTypes.TASK_EDIT_ENABLED:
            return {isReadOnly: false};
        case ActionTypes.TASK_EDIT_CANCELLED:
            return {isReadOnly: true};
        // Prevent any rehydration
        // @ts-expect-error
        case 'persist/REHYDRATE': {
            // @ts-expect-error
            return state;
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
